module.exports = __webpack_public_path__ + "media/images/lb/381-518f706c88d5777c160dabd4141311cd.svg";